/* eslint-disable */
import { call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import PaypalActions from '../Redux/PaypalRedux'
import { /*AsyncStorage,*/ Alert } from 'react-native'

import { AsyncStorage } from '@react-native-async-storage/async-storage'

export const paypalStatus = function* paypalStatus(api, action) {
  const { status, then, err } = action.status
  try {
    //yield put(PaypalActions.paypalStatusRequest(action))
    console.tron.display({
      name : 'paypalStatus'
    , preview : 'Saga paypal token status, Acquire paypal token status or a nonce to allow user login'
    , value : { action : action }
    })
   
    // make the call to the api
    const response = yield call( api.paypalStatus, { } )
    console.tron.display( { name : 'paypalStatus'
                          , preview : 'Saga api paypalStatus apiResponse (token)'
                          , value: { response : response }
                          } )
    if( response.ok ) {
      yield call ( then, response )
      yield put(PaypalActions.paypalStatusSuccess(response))
    } else {
      // const { data : { errors } } = response
      //Alert.alert(JSON.stringify(errors))
      err('Sorry, unable to determine your Paypal Status at this time')
      yield put(PaypalActions.paypalStatusFailure(response))
    }
  } catch (e) {
    //Alert.alert(JSON.stringify(e))
    yield put(PaypalActions.paypalStatusFailure(e))
    console.tron.display( { name: 'paypalStatus'
                          , preview: 'Saga error requesting paypal oauth token'
                          , value : { message : e.message
                                    , e : e
                                    }
                          } )
    err ( e )
  }
}
export const paypalLogout = function* paypalLogout(api, action) {
  try {
    const { status, then, err } = action.status
    const response = yield call( api.paypalLogout, { } )
    if( response.ok ) {
      yield call ( then, response )
      yield put (PaypalActions.paypalLogoutSuccess(response))
    } else {
      yield put (PaypalActions.paypalLogoutFailure(response))
    }
  } catch ( e ) {
    yield put (PaypalActions.paypalLogoutFailure(e))
    err ( e )
  }
}
